!function webpackUniversalModuleDefinition(e, t) {
  if ("object" === typeof exports && "object" === typeof module) module.exports = t();else if ("function" === typeof define && define.amd) define([], t);else {
    var r = t();

    for (var n in r) {
      ("object" === typeof exports ? exports : e)[n] = r[n];
    }
  }
}(window, function () {
  return function (e) {
    var t = {};

    function __webpack_require__(r) {
      if (t[r]) return t[r].exports;
      var n = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(n.exports, n, n.exports, __webpack_require__), n.l = !0, n.exports;
    }

    return __webpack_require__.m = e, __webpack_require__.c = t, __webpack_require__.d = function (e, t, r) {
      __webpack_require__.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, __webpack_require__.r = function (e) {
      "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, __webpack_require__.t = function (e, t) {
      if (1 & t && (e = __webpack_require__(e)), 8 & t) return e;
      if (4 & t && "object" === typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (__webpack_require__.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var n in e) {
        __webpack_require__.d(r, n, function (t) {
          return e[t];
        }.bind(null, n));
      }
      return r;
    }, __webpack_require__.n = function (e) {
      var t = e && e.__esModule ? function getDefault() {
        return e.default;
      } : function getModuleExports() {
        return e;
      };
      return __webpack_require__.d(t, "a", t), t;
    }, __webpack_require__.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, __webpack_require__.p = "/", __webpack_require__(__webpack_require__.s = 1);
  }([function (e, t, r) {
    e.exports = r(2);
  }, function (e, t, r) {
    e.exports = r(3);
  }, function (e, t, r) {
    var n = function (e) {
      "use strict";

      var t,
          r = Object.prototype,
          n = r.hasOwnProperty,
          o = "function" === typeof Symbol ? Symbol : {},
          a = o.iterator || "@@iterator",
          i = o.asyncIterator || "@@asyncIterator",
          c = o.toStringTag || "@@toStringTag";

      function define(e, t, r) {
        return Object.defineProperty(e, t, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), e[t];
      }

      try {
        define({}, "");
      } catch (v) {
        define = function define(e, t, r) {
          return e[t] = r;
        };
      }

      function wrap(e, t, r, n) {
        var o = t && t.prototype instanceof Generator ? t : Generator,
            a = Object.create(o.prototype),
            i = new Context(n || []);
        return a._invoke = function makeInvokeMethod(e, t, r) {
          var n = u;
          return function invoke(o, a) {
            if (n === s) throw new Error("Generator is already running");

            if (n === f) {
              if ("throw" === o) throw a;
              return doneResult();
            }

            for (r.method = o, r.arg = a;;) {
              var i = r.delegate;

              if (i) {
                var c = maybeInvokeDelegate(i, r);

                if (c) {
                  if (c === h) continue;
                  return c;
                }
              }

              if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                if (n === u) throw n = f, r.arg;
                r.dispatchException(r.arg);
              } else "return" === r.method && r.abrupt("return", r.arg);
              n = s;
              var p = tryCatch(e, t, r);

              if ("normal" === p.type) {
                if (n = r.done ? f : l, p.arg === h) continue;
                return {
                  value: p.arg,
                  done: r.done
                };
              }

              "throw" === p.type && (n = f, r.method = "throw", r.arg = p.arg);
            }
          };
        }(e, r, i), a;
      }

      function tryCatch(e, t, r) {
        try {
          return {
            type: "normal",
            arg: e.call(t, r)
          };
        } catch (v) {
          return {
            type: "throw",
            arg: v
          };
        }
      }

      e.wrap = wrap;
      var u = "suspendedStart",
          l = "suspendedYield",
          s = "executing",
          f = "completed",
          h = {};

      function Generator() {}

      function GeneratorFunction() {}

      function GeneratorFunctionPrototype() {}

      var p = {};

      p[a] = function () {
        return this;
      };

      var d = Object.getPrototypeOf,
          _ = d && d(d(values([])));

      _ && _ !== r && n.call(_, a) && (p = _);
      var y = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);

      function defineIteratorMethods(e) {
        ["next", "throw", "return"].forEach(function (t) {
          define(e, t, function (e) {
            return this._invoke(t, e);
          });
        });
      }

      function AsyncIterator(e, t) {
        var r;

        this._invoke = function enqueue(o, a) {
          function callInvokeWithMethodAndArg() {
            return new t(function (r, i) {
              !function invoke(r, o, a, i) {
                var c = tryCatch(e[r], e, o);

                if ("throw" !== c.type) {
                  var u = c.arg,
                      l = u.value;
                  return l && "object" === typeof l && n.call(l, "__await") ? t.resolve(l.__await).then(function (e) {
                    invoke("next", e, a, i);
                  }, function (e) {
                    invoke("throw", e, a, i);
                  }) : t.resolve(l).then(function (e) {
                    u.value = e, a(u);
                  }, function (e) {
                    return invoke("throw", e, a, i);
                  });
                }

                i(c.arg);
              }(o, a, r, i);
            });
          }

          return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        };
      }

      function maybeInvokeDelegate(e, r) {
        var n = e.iterator[r.method];

        if (n === t) {
          if (r.delegate = null, "throw" === r.method) {
            if (e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method)) return h;
            r.method = "throw", r.arg = new TypeError("The iterator does not provide a 'throw' method");
          }

          return h;
        }

        var o = tryCatch(n, e.iterator, r.arg);
        if ("throw" === o.type) return r.method = "throw", r.arg = o.arg, r.delegate = null, h;
        var a = o.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, h) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, h);
      }

      function pushTryEntry(e) {
        var t = {
          tryLoc: e[0]
        };
        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
      }

      function resetTryEntry(e) {
        var t = e.completion || {};
        t.type = "normal", delete t.arg, e.completion = t;
      }

      function Context(e) {
        this.tryEntries = [{
          tryLoc: "root"
        }], e.forEach(pushTryEntry, this), this.reset(!0);
      }

      function values(e) {
        if (e) {
          var r = e[a];
          if (r) return r.call(e);
          if ("function" === typeof e.next) return e;

          if (!isNaN(e.length)) {
            var o = -1,
                i = function next() {
              for (; ++o < e.length;) {
                if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
              }

              return next.value = t, next.done = !0, next;
            };

            return i.next = i;
          }
        }

        return {
          next: doneResult
        };
      }

      function doneResult() {
        return {
          value: t,
          done: !0
        };
      }

      return GeneratorFunction.prototype = y.constructor = GeneratorFunctionPrototype, GeneratorFunctionPrototype.constructor = GeneratorFunction, GeneratorFunction.displayName = define(GeneratorFunctionPrototype, c, "GeneratorFunction"), e.isGeneratorFunction = function (e) {
        var t = "function" === typeof e && e.constructor;
        return !!t && (t === GeneratorFunction || "GeneratorFunction" === (t.displayName || t.name));
      }, e.mark = function (e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, define(e, c, "GeneratorFunction")), e.prototype = Object.create(y), e;
      }, e.awrap = function (e) {
        return {
          __await: e
        };
      }, defineIteratorMethods(AsyncIterator.prototype), AsyncIterator.prototype[i] = function () {
        return this;
      }, e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, a) {
        void 0 === a && (a = Promise);
        var i = new AsyncIterator(wrap(t, r, n, o), a);
        return e.isGeneratorFunction(r) ? i : i.next().then(function (e) {
          return e.done ? e.value : i.next();
        });
      }, defineIteratorMethods(y), define(y, c, "Generator"), y[a] = function () {
        return this;
      }, y.toString = function () {
        return "[object Generator]";
      }, e.keys = function (e) {
        var t = [];

        for (var r in e) {
          t.push(r);
        }

        return t.reverse(), function next() {
          for (; t.length;) {
            var r = t.pop();
            if (r in e) return next.value = r, next.done = !1, next;
          }

          return next.done = !0, next;
        };
      }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) {
            "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
          }
        },
        stop: function stop() {
          this.done = !0;
          var e = this.tryEntries[0].completion;
          if ("throw" === e.type) throw e.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(e) {
          if (this.done) throw e;
          var r = this;

          function handle(n, o) {
            return i.type = "throw", i.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
          }

          for (var o = this.tryEntries.length - 1; o >= 0; --o) {
            var a = this.tryEntries[o],
                i = a.completion;
            if ("root" === a.tryLoc) return handle("end");

            if (a.tryLoc <= this.prev) {
              var c = n.call(a, "catchLoc"),
                  u = n.call(a, "finallyLoc");

              if (c && u) {
                if (this.prev < a.catchLoc) return handle(a.catchLoc, !0);
                if (this.prev < a.finallyLoc) return handle(a.finallyLoc);
              } else if (c) {
                if (this.prev < a.catchLoc) return handle(a.catchLoc, !0);
              } else {
                if (!u) throw new Error("try statement without catch or finally");
                if (this.prev < a.finallyLoc) return handle(a.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(e, t) {
          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var o = this.tryEntries[r];

            if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
              var a = o;
              break;
            }
          }

          a && ("break" === e || "continue" === e) && a.tryLoc <= t && t <= a.finallyLoc && (a = null);
          var i = a ? a.completion : {};
          return i.type = e, i.arg = t, a ? (this.method = "next", this.next = a.finallyLoc, h) : this.complete(i);
        },
        complete: function complete(e, t) {
          if ("throw" === e.type) throw e.arg;
          return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), h;
        },
        finish: function finish(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var r = this.tryEntries[t];
            if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), h;
          }
        },
        catch: function _catch(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var r = this.tryEntries[t];

            if (r.tryLoc === e) {
              var n = r.completion;

              if ("throw" === n.type) {
                var o = n.arg;
                resetTryEntry(r);
              }

              return o;
            }
          }

          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
          return this.delegate = {
            iterator: values(e),
            resultName: r,
            nextLoc: n
          }, "next" === this.method && (this.arg = t), h;
        }
      }, e;
    }(e.exports);

    try {
      regeneratorRuntime = n;
    } catch (o) {
      Function("r", "regeneratorRuntime = r")(n);
    }
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0),
        o = r.n(n);

    function asyncGeneratorStep(e, t, r, n, o, a, i) {
      try {
        var c = e[a](i),
            u = c.value;
      } catch (l) {
        return void r(l);
      }

      c.done ? t(u) : Promise.resolve(u).then(n, o);
    }

    function _asyncToGenerator(e) {
      return function () {
        var t = this,
            r = arguments;
        return new Promise(function (n, o) {
          var a = e.apply(t, r);

          function _next(e) {
            asyncGeneratorStep(a, n, o, _next, _throw, "next", e);
          }

          function _throw(e) {
            asyncGeneratorStep(a, n, o, _next, _throw, "throw", e);
          }

          _next(void 0);
        });
      };
    }

    r.d(t, "fireSEQ", function () {
      return s;
    });

    var a = function fetchInteractions() {
      return fetch("https://static.drift.com/config/SEQ-config/index.json").then(function (e) {
        return e.json();
      });
    },
        i = null,
        c = function () {
      var e = _asyncToGenerator(o.a.mark(function _callee2() {
        return o.a.wrap(function _callee2$(e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", new Promise(function () {
                  var e = _asyncToGenerator(o.a.mark(function _callee(e, t) {
                    var r;
                    return o.a.wrap(function _callee$(n) {
                      for (;;) {
                        switch (n.prev = n.next) {
                          case 0:
                            if (!i) {
                              n.next = 2;
                              break;
                            }

                            return n.abrupt("return", e(i));

                          case 2:
                            return n.prev = 2, n.next = 5, a();

                          case 5:
                            r = n.sent, i = r, e(r), n.next = 13;
                            break;

                          case 10:
                            n.prev = 10, n.t0 = n.catch(2), t(n.t0);

                          case 13:
                          case "end":
                            return n.stop();
                        }
                      }
                    }, _callee, null, [[2, 10]]);
                  }));

                  return function (t, r) {
                    return e.apply(this, arguments);
                  };
                }()));

              case 1:
              case "end":
                return e.stop();
            }
          }
        }, _callee2);
      }));

      return function getSEQInteractions() {
        return e.apply(this, arguments);
      };
    }(),
        u = function shouldFireSeq(e) {
      if (!window.localStorage) return !0;
      var t = window.localStorage.getItem("_seq_bot_".concat(e, "_last_fired"));
      return !t || (Math.round(Math.abs((new Date(t) - new Date()) / 864e5)) >= 28 ? (window.localStorage.removeItem("_seq_bot_".concat(e, "_last_fired")), !0) : void 0);
    },
        l = function setInteractionFiredHistory(e) {
      window.localStorage && window.localStorage.setItem("_seq_bot_".concat(e, "_last_fired"), new Date());
    },
        s = function () {
      var e = _asyncToGenerator(o.a.mark(function _callee3(e) {
        var t, r, n;
        return o.a.wrap(function _callee3$(o) {
          for (;;) {
            switch (o.prev = o.next) {
              case 0:
                if ("PRODUCTION" === window.__ENV__ && u(e)) {
                  o.next = 3;
                  break;
                }

                return o.abrupt("return");

              case 3:
                return o.prev = 3, o.next = 6, c();

              case 6:
                if (r = o.sent, n = null !== (t = r[e]) && void 0 !== t ? t : null, window.drift && n && "disabled" !== n) {
                  o.next = 10;
                  break;
                }

                return o.abrupt("return");

              case 10:
                window.drift && window.drift("startInteraction", {
                  interactionId: n,
                  replaceActiveConversation: !1
                }), l(e), o.next = 17;
                break;

              case 14:
                return o.prev = 14, o.t0 = o.catch(3), o.abrupt("return");

              case 17:
              case "end":
                return o.stop();
            }
          }
        }, _callee3, null, [[3, 14]]);
      }));

      return function fireSEQ(t) {
        return e.apply(this, arguments);
      };
    }();
  }]);
});